import type { AxiosRequestHeaders } from 'axios';

/**
 * Puts the caller's bearer token on a request, for the API clients' interceptors.
 *
 * It replaces any `Authorization` header already present, whatever its case or value (including
 * `false`, which axios's default `set` would keep). With no token it leaves the headers exactly as
 * they are.
 */
export const setBearerAuthorization = (
  headers: AxiosRequestHeaders,
  token: string | null | undefined
): void => {
  if (token) {
    headers.set('Authorization', `Bearer ${token}`, true);
  }
};
